import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "about-us" }
const _hoisted_2 = { class: "about-us-banner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "about-us-content" }
const _hoisted_5 = { class: "company-profile" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "ryzz honor" }
const _hoisted_8 = { class: "ryzz-list" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "xwzx" }
const _hoisted_11 = { class: "xwzx-box" }
const _hoisted_12 = { class: "news-content" }
const _hoisted_13 = ["onClick"]

import { ref, watch, onMounted, onUnmounted, reactive } from 'vue'
import { selectCommonElement, addConsult } from '@/api'
import router from '@/router';
import { asynchronousRetrieval } from '@/utils'

export default /*@__PURE__*/_defineComponent({
  __name: 'AboutUsView',
  setup(__props) {

const loadUrl: any = ref({})

const showIndexs: any = ref([3, 0, 1, 2, 3])
let timer: any = null;
let timer2: any = null;
let timer3: any = null;
let clicks: any = false;
const newsList: any = ref([])
const honors = [
  {
    url: require('@/assets/images/about_us/ryzz1.png'),
    illustrate: ['2023上海最具投资潜力']
  },
  {
    url: require('@/assets/images/about_us/ryzz2.png'),
    illustrate: ['“创客中国”元宇宙（人工智能）']
  },
  {
    url: require('@/assets/images/about_us/ryzz3.png'),
    illustrate: ['2023数智创新优胜奖']
  },
  {
    url: require('@/assets/images/about_us/ryzz6.png'),
    illustrate: ['2024年度典型案例']
  },
  {
    url: require('@/assets/images/about_us/ryzz7.png'),
    illustrate: ['上海市创新创业大赛 优胜奖']
  },
]

const active_r_i = ref(1)
const showHonors: any = ref([])
const activeIndex = ref(2)
const activeNewsIndex = ref(0)


const toOtherPath = (relatedHtmlId: number, title: string) => {
  router.push(`/details?relatedHtmlId=${relatedHtmlId}`)
}

const prevEvent = () => {
  if (clicks) return;
  clicks = true;
  (document.querySelector('.honors-box') as any).style.transition = 'all .5s';
  (document.querySelectorAll('.honors-box>div') as any).forEach((ele: any) => {
    ele.style.transition = 'all .5s'
  });
  if (active_r_i.value != 0) {
    active_r_i.value -= 1;
  } else {
    active_r_i.value = honors.length - 1
  }
  activeIndex.value -= 1;
}

const nextEvent = () => {
  if (clicks) return;
  clicks = true;
  (document.querySelector('.honors-box') as any).style.transition = 'all .5s';
  (document.querySelectorAll('.honors-box>div') as any).forEach((ele: any) => {
    ele.style.transition = 'all .5s'
  });
  if (active_r_i.value != honors.length - 1) {
    active_r_i.value += 1;
  } else {
    active_r_i.value = 0
  }
  activeIndex.value += 1;
}
onMounted(async () => {
  showHonors.value = showIndexs.value.map((k: number) => honors[k]);
  clearInterval(timer)
  timer = setInterval(() => {
    nextEvent()
  }, 3000)

  selectCommonElement({ columnId: 5, appId: 2 }).then((res: any) => {
    newsList.value = res.slice(0, 4).map((e: any) => {
      const date = new Date(e.newsTimestamp || e.createTime)
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      e.times = `${y}-${m}-${d}`
      return e;
    })
  })

  clearInterval(timer3)
  timer3 = setInterval(() => {
    activeNewsIndex.value += 1;
    if (activeNewsIndex.value > 3) {
      activeNewsIndex.value = 0;
    }
  }, 3000)

  const particle_moment_mp4: any = await asynchronousRetrieval('webimg/images/home/particles-moment.mp4');
  const banner_bg: any = await asynchronousRetrieval('webimg/images/about_us/banner-bg.png');
  const company_profile: any = await asynchronousRetrieval('webimg/images/about_us/company-profile.png');
  loadUrl.value = { particle_moment_mp4, banner_bg, company_profile }
})

onUnmounted(() => {
  clearInterval(timer)
  clearInterval(timer2)
  clearInterval(timer3)
})

watch(active_r_i, (newState) => {
  clearInterval(timer)
  showIndexs.value = showIndexs.value.map((v: number, i: number) => {
    if (i < 2) {
      if ((newState - (2 - i)) >= 0) {
        return newState - (2 - i)
      } else {
        return (honors.length + newState) - (2 - i)
      }
    }
    if (i == 2) return newState
    if (i > 2) {
      if ((newState < honors.length - 2) || (newState + (i - 2) < honors.length)) {
        return newState + (i - 2)
      } else {
        return newState + (i - 2) - honors.length
      }
    }
  });
  clearTimeout(timer2)
  timer2 = setTimeout(() => {
    (document.querySelector('.honors-box') as any).style.transition = 'none';
    (document.querySelectorAll('.honors-box>div') as any).forEach((ele: any) => {
      ele.style.transition = 'none'
    });
    showHonors.value = showIndexs.value.map((k: number) => honors[k]);
    activeIndex.value = 2
    clicks = false
    clearInterval(timer)
    timer = setInterval(() => {
      nextEvent()
    }, 3000)
  }, 500)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: loadUrl.value.banner_bg
      }, null, 8, _hoisted_3),
      _cache[0] || (_cache[0] = _createElementVNode("div", null, "关于我们", -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "introduce" }, [
        _createElementVNode("div", null, "公司介绍"),
        _createElementVNode("div", null, [
          _createElementVNode("div", null, "混空（Mixed Space）是一家专注元宇宙数实融合场景建设的公司，深耕XR+AI技术突破，以技术平台为发展引擎，为各行业提供元宇宙数实融合的解决方案。"),
          _createElementVNode("div", null, "混空自研核心底层技术VPS（Visual Positioning System），通过AI视觉算法与多源数据融合，实现厘米级空间定位。具备抗遮挡、低延迟、多设备兼容等特性，适用于AR导航和城市级大空间定位场景。同时，客户可通过公司自研的元宇宙内容创作与分发平台——混空 Studio（智能体），一站式完成空间数字化建模和元宇宙互动营销场景创作，并通过XR眼镜、手机等实现跨端数实融合体验。"),
          _createElementVNode("div", null, "以行业应用为导向，公司在文娱、商业、工业、教育等领域已有诸多成功案例，切实帮助全行业实现数实升级、提质增效。公司获得国家双软企业认定和国家科技型中小企业认定，已申请近60项软件著作和知识产权，并凭借数实融合技术多次斩获国内投资价值类奖项，成为元宇宙、数智化领域的头部公司。")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          src: loadUrl.value.company_profile
        }, null, 8, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title" }, "荣誉资质", -1)),
        _createElementVNode("div", {
          class: "prev",
          onClick: prevEvent
        }),
        _createElementVNode("div", {
          class: "next",
          onClick: nextEvent
        }),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: "honors-box",
            style: _normalizeStyle({ left: -(activeIndex.value - 1) * 232 + 'rem' })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showHonors.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(index == activeIndex.value ? 'active' : '')
              }, [
                _createElementVNode("img", {
                  src: item.url
                }, null, 8, _hoisted_9),
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.illustrate, (e, i) => {
                    return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(e), 1))
                  }), 128))
                ])
              ], 2))
            }), 128))
          ], 4)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "title-font-style title" }, "公司动态", -1)),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newsList.value, (e, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                onClick: ($event: any) => (toOtherPath(e.relatedHtmlId, e.title)),
                class: _normalizeClass(activeNewsIndex.value == i ? 'active' : '')
              }, [
                _createElementVNode("div", null, _toDisplayString(e.title), 1),
                _createElementVNode("div", null, _toDisplayString(e.times), 1)
              ], 10, _hoisted_13))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}
}

})